/**
 * voice-v8 — Der Entwurf bleibt, bis der Server die Nachricht angenommen hat.
 * (11.10.2026, Ticket 2845)
 *
 * Martin, 30.09. und 01.10.: Der Text stand sichtbar im Feld, wurde abgeschickt
 * und war weg — Vespera antwortete, sie habe nichts gehört. Die Ursache vom
 * 30.09. lag am Server (Pegelprüfung, pre.3536). Übrig blieb eine Lücke im
 * getippten Weg: `handleTextSubmit` leert das Feld VOR dem Senden und schaute
 * danach nie, ob die Nachricht ankam. Ging der Abruf schief (offline, Server
 * lehnt ab), stand der Text nur noch in einer Blase — wer ihn noch einmal
 * schicken wollte, musste ihn neu tippen.
 *
 * Hier steht nur die EINE Entscheidung, was nach einem Sendeversuch im Feld
 * stehen soll — und „nicht angekommen“ heißt: der Server hat NICHT mit 200 geantwortet.
 * Danach rechnet er weiter (server/chat.ts, Ticket 2256); ein zweites Senden liefe doppelt. Das Schreiben ins Feld bleibt in app.ts.
 *
 * ⚠️ Nie überschreiben: Hat Martin inzwischen etwas Neues getippt, bleibt es
 *    stehen, der alte Entwurf kommt davor.
 * ⚠️ Nie verdoppeln: Steht GENAU der Text schon im Feld (zweiter Versuch, Wiederholung
 *    desselben Fehlers), ändert sich nichts.
 * ⚠️ Nur exakt vergleichen, nie „enthält“: Wer „ok“ schickte, während im Feld inzwischen
 *    „okay, dann …“ steht, hätte seinen Text sonst still verloren (Prüfbefund 11.10.).
 */

/**
 * Was ins Feld gehört, nachdem `gesendet` abgeschickt wurde.
 *
 * @param feldJetzt   Inhalt des Feldes in diesem Moment
 * @param gesendet    der Text, der das Feld verlassen hat
 * @param angekommen  hat der Server die Nachricht angenommen?
 * @returns der neue Feldinhalt — oder `null`, wenn am Feld nichts zu tun ist
 */
export function entwurfZurueck(feldJetzt: string, gesendet: string, angekommen: boolean): string | null {
  if (angekommen) return null;
  const text = gesendet.trim();
  if (text === "") return null;
  const bisher = feldJetzt.trim();
  if (bisher === "") return text;
  if (bisher === text) return null;
  return `${text}\n${bisher}`;
}
